import './users.css';
import { Outlet } from 'react-router-dom';

const Users = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default Users;
